import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExamDetailsComponent } from '../exam-details/exam-details.component';
import { ExamService } from '../services/exam.service';
import { CourseService } from '../services/course.service';
import { FormControl } from '@angular/forms';
import { ThrowStmt } from '@angular/compiler';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-exam-view',
  templateUrl: './exam-view.component.html',
  styleUrls: ['./exam-view.component.css']
})
export class ExamViewComponent implements OnInit {
  exams: [] = [];
  examCode = ' ';
  courses: [] = [];
  courseCode = ' ';
  public courseCtrl: FormControl = new FormControl();
  selId: any;
  selIndex: any;
  length = 0;
  page = 0;
  pageSize = 10;

  constructor(public examService: ExamService,
              public courseService: CourseService,
              public g:Globals

    ) {


     }


  ngOnInit() {
    this.courseService.get().then(res => {
      this.courses = (res as any).data;
      console.log(this.courses);

           });
    this.getExams();

  }


  onPageChange(e)
  {


    this.page = e.pageIndex;
   
    this.getExams();

  }
  deleteExam(id, index)
  {
    this.selId = id;
    this.selIndex = index;


  }

  cancel()
  {
    this.selId = 0;
    this.selIndex = -1;
  }
  confirmDelete()
  {

    this.examService.deleteExam(this.selId).then(res =>
      {
        this.exams.splice(this.selIndex, 1);
      }
      );
  }

  getExams()
  {
    this.courseCode = this.courseCtrl.value;

    if (this.examCode == '')
    {
      this.examCode = ' ';
    }
    this.loadExams();
  }

  private loadExams() {
    this.examService.get(this.examCode, this.courseCode, this.page + 1, this.pageSize).then(res => {
      console.log(res);
      this.exams = (res as any).data;
      this.length = (res as any).dataLength;

    }
    );
  }
}
